import { Component } from '@angular/core';

@Component({
  selector: 'no-content',
  template: require('./no-content.component.html'),
  styles: [require('./no-content.component.css')]
})
export class NoContentComponent {

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/no-content/no-content.component.ts